<template>
  <div>
    <router-view class="view" keep-alive transition transition-mode="out-in" />
    <page-listar v-if="isIndexOnly()" />
  </div>
</template>

<script>
import Listar from './Listar'

export default {
  name: 'aplicativos',
  data () {
    return {
      title: 'Apps'
    }
  },
  components: {
    'page-listar': Listar
  },
  methods: {
    isIndexOnly () {
      return this.$router.currentRoute.path === '/aplicativos' || this.$router.currentRoute.path === '/aplicativos/'
    }
  },
  mounted () {
    this.$parent.$data.title = this.title
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/aplicativos/index.vue